import { FormSaveRequest } from '../../../infrastructure';

async function FormSave(event) {
    const response = await FormSaveRequest(event);

    return response;
}

export default FormSave;
